import util from '@bmp-vue/core/api/util'

const controller = 'ContaPagadorBoletos'
export default Object.assign({}, util.GetCrud(controller, ['get', 'post']))
